import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { Box, Divider, useTheme } from '@mui/material'

import { HHAlert } from 'components/common/HHAlert'
import { handleError } from 'utils/error'
import { useLazyGetRentalFeesLinkedToAccountQuery } from 'api/pricing/rentalFeesCrud'

import T from 'T'
import HHAccordion from 'components/common/HHAccordion'
import RentalFeeAccordionItem from './RentalFeeAccordionItem'
import ListSkeleton from './ListSkeleton'

const RentalFeesAccordion = ({ accountId }) => {
  const theme = useTheme()
  const [getRentalFeesLinkedToAccount, { isLoading, data: rentalFees = [] }] = useLazyGetRentalFeesLinkedToAccountQuery()
  const hasRentalFees = rentalFees.length > 0

  useEffect(() => {
    if (accountId) {
      getRentalFeesLinkedToAccount({ accountId }).unwrap().catch(handleError)
    }
  }, [accountId])

  return (
    <HHAccordion withNewColors isExpanded isExpandCollapseHeightSame summary={T.RENTAL} showActionIcon={false}>
      <Box
        width="100%"
        sx={{
          ...(!hasRentalFees && { p: 2 }),
        }}
      >
        {isLoading && <ListSkeleton />}
        {!isLoading && !hasRentalFees && (
          <HHAlert severity="info" borderColor={theme.palette.info.main}>
            No rental fees on this account yet
          </HHAlert>
        )}
        {!isLoading &&
          rentalFees.map(rentalFee => (
            <>
              <RentalFeeAccordionItem accountId={accountId} rentalFee={rentalFee} />
              <Divider />
            </>
          ))}
      </Box>
    </HHAccordion>
  )
}

RentalFeesAccordion.propTypes = {
  accountId: PropTypes.string,
}

export default RentalFeesAccordion
